<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8wTAny/tc-custom/9780300147681.jpg?1705539782354" alt="This image is the cover for the book Tactics and the Experience of Battle in the Age of Napoleon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tactics and the Experience of Battle in the Age of Napoleon
      </h1>
      <p class="bookDescription body article font2">
        <b>This historical study of Napoleonic battles and tactics examines firsthand accounts from soldiers’ memoirs, diaries, and letters: “A major work” (David Seymour, <i>Military Illustrated</i>).</b><br/>  <br/> In this illuminating volume, historian Rory Muir explores what actually happened in battle during the Napoleonic Wars, putting special focus on how the participants’ feelings and reactions influenced the outcome. Looking at the immediate dynamics of combat, Muir sheds new light on how Napoleon’s tactics worked. This analysis is enhanced with vivid accounts of those who were there—the frightened foot soldier, the general in command, the young cavalry officer whose boils made it impossible to ride, and the smartly dressed aide-de-camp, tripped up by his voluminous pantaloons.<br/><br/> Muir considers the interaction of artillery, infantry, and cavalry; the role of the general, subordinate commanders, staff officers, and aides; morale, esprit de corps, soldiers’ attitudes toward death and feelings about the enemy; the plight of the wounded; the difficulty of surrendering; and the way victories were finally decided. He discusses the mechanics of musketry, artillery, and cavalry charges and shows how they influenced the morale, discipline, and resolution of the opposing armies.<br/>  <br/><b>"Muir has filled an important gap in the study of the Napoleonic era."—<i>Library Journal</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rory Muir
      </h2>
      
      <p class="authorDescription body article">Rory Muir is a visiting research fellow at the University of Adelaide. He is the author of Britain and the Defeat of Napoleon, 1807-1815, published by Yale University Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Yale University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cda7724e